import { createContext } from 'react';
// ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `dw-neit-rc-field-form`
export default createContext(undefined);
